import { api } from '../../api';

import type { ReviewSchedule } from '@/types/review/ReviewSchedule';

const scheduleService = {
    async getSchedule(scheduleId: string): Promise<ReviewSchedule> {
        const response = await api.get(`/reviewschedule/${scheduleId}`);
        return response.data;
    },

    async updateSchedule(schedule: ReviewSchedule): Promise<ReviewSchedule> {
        const response = await api.put(`/reviewschedule/${schedule.id}`, schedule);
        return response.data;
    },
};

export default scheduleService;
